
import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";

export default () => [
    {
        pages: [paths.assistance],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "CODIGO DE EMPLEADO",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.assistance],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "APELLIDO Y NOMBRE",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.assistance],
        config: {
            headerName: getLocalizedString("inDate"),
            field: "FECHA DE ENTRADA",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: [paths.assistance],
        config: {
            headerName: getLocalizedString("inHour"),
            field: "HORA DE ENTRADA",
            filter: "agTextColumnFilter",
            valueGetter: function (params) {
                return (params.data && (params.data["HORA DE ENTRADA"] || "")) || "";
            },
        }
    },
    {
        pages: [paths.assistance],
        config: {
            headerName: getLocalizedString("outDate"),
            field: "FECHA DE SALIDA",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: [paths.assistance],
        config: {
            headerName: getLocalizedString("outHour"),
            field: "HORA DE SALIDA",
            filter: "agTextColumnFilter",
            valueGetter: function (params) {
                return (params.data && (params.data["HORA DE SALIDA"] || "")) || "";
            },
        }
    },
    {
        pages: [paths.assistance],
        config: {
            headerName: getLocalizedString("scheduledTime"),
            field: "HORARIO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.assistance],
        config: {
            headerName: getLocalizedString("scheduledHours"),
            field: "HORAS PROGRAMADAS",
            filter: "agTextColumnFilter",
            valueGetter: function (params) {
                return (params.data && (params.data["HORAS PROGRAMADAS"] || "")) || "";
            },
        }
    },
    {
        pages: [paths.assistance],
        config: {
            headerName: getLocalizedString("timeBetweenMarks"),
            field: "TIEMPO TRANSCURRIDO ENTRE MARCAS",
            cellRenderer: "TimeBetweenMarksRenderer",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.assistance],
        config: {
            headerName: getLocalizedString("difference"),
            field: "DIFERENCIA",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.assistance],
        config: {
            headerName: getLocalizedString("entryAttendancePlace"),
            field: "LUGAR DE ASISTENCIA ENTRADA",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.assistance],
        config: {
            headerName: getLocalizedString("entryCoordinates"),
            field: 'hasEntryGPSCoordinates',
            filter: "agSetColumnFilter",
            cellRenderer: "PositionImageRenderer",
        }
    },
    {
        pages: [paths.assistance],
        config: {
            headerName: getLocalizedString("entryReference"),
            field: 'REFERENCIA ENTRADA',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.assistance],
        config: {
            headerName: getLocalizedString("inputSource"),
            field: "ORIGEN ENTRADA",
            filter: "agSetColumnFilter",
        }
    },

    {
        pages: [paths.assistance],
        config: {
            headerName: getLocalizedString("assistanceExitPlace"),
            field: "LUGAR DE ASISTENCIA SALIDA",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.assistance],
        config: {
            headerName: getLocalizedString("exitCoordinates"),
            field: 'hasExitGPSCoordinates',
            filter: "agSetColumnFilter",
            cellRenderer: "PositionImageRenderer",
        }
    },
    {
        pages: [paths.assistance],
        config: {
            headerName: getLocalizedString("exitReference"),
            field: 'REFERENCIA SALIDA',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.assistance],
        config: {
            headerName: getLocalizedString("exitOrigin"),
            field: "ORIGEN SALIDA",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.assistance],
        config: {
            headerName: getLocalizedString("cant"),
            field: "CANTIDAD",
        }
    },
    {
        pages: [paths.assistance],
        config: {
            headerName: getLocalizedString("outOfZoneIN"),
            field: "FUERA DE ZONA (ENTRADA)",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.assistance],
        config: {
            headerName: getLocalizedString("outOfZoneOUT"),
            field: "FUERA DE ZONA (SALIDA)",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.assistance],
        config: {
            headerName: getLocalizedString("comments"),
            field: "COMENTARIOS",
            filter: "agTextColumnFilter",
        }
    },
]